export default __webpack_public_path__ + "images/832c7c271780e294efca53937f69bf72-bg-04.jpg";